import Dialog from '@material-ui/core/Dialog';
import DialogContent from '@material-ui/core/DialogContent';
import DialogTitle from '@material-ui/core/DialogTitle';
import { makeStyles } from '@material-ui/styles';
import React from 'react';

import { Colors } from 'src/common/ui/base';
import { EditIdSubmissionForm } from 'src/idVerification/components/EditIdSubmissionForm';
import { IdImageSet } from 'src/idVerification/components/IdImage';
import { PatientPhotoDisplay } from 'src/idVerification/components/PatientPhotoDisplay';
import { IdSubmission } from 'src/idVerification/types';

type IdSubmissionDialogProps = {
  isOpen: boolean;
  onCancel: () => void;
  setCurrentSubmission: React.Dispatch<React.SetStateAction<IdSubmission | null>>;
  submission: IdSubmission;
  mutate: () => void;
};

export const IdSubmissionDialog = ({
  isOpen,
  onCancel,
  setCurrentSubmission,
  submission,
  mutate,
}: IdSubmissionDialogProps) => {
  const styles = useStyles();

  if (!submission) {
    return null;
  }

  return (
    <Dialog fullWidth maxWidth="lg" open={isOpen} onClose={onCancel}>
      <DialogTitle classes={{ root: styles.title }}>Verify Submission</DialogTitle>
      <DialogContent>
        <div className={styles.contentContainer}>
          <div className={styles.imageContainer}>
            <IdImageSet imageIds={submission.imageIds} />
          </div>
          <div className={styles.sidebarContainer}>
            <div className={styles.stickyContent}>
              <PatientPhotoDisplay patientId={submission.patientId} />
              <EditIdSubmissionForm
                item={submission}
                onCancel={onCancel}
                setCurrentSubmission={setCurrentSubmission}
                mutate={mutate}
              />
            </div>
          </div>
        </div>
      </DialogContent>
    </Dialog>
  );
};

const useStyles = makeStyles({
  title: {
    '& .MuiTypography-root': {
      color: Colors.Gray5,
      fontFamily: 'Tenor Sans',
      fontSize: 24,
      fontStyle: 'normal',
      fontWeight: 400,
      lineHeight: 1.45,
      letterSpacing: 0.2,
    },
  },
  contentContainer: {
    display: 'flex',
    gap: 24,
  },
  imageContainer: {
    flex: '1 1 auto',
    maxWidth: '70%',
  },
  sidebarContainer: {
    flex: '0 0 250px',
    position: 'relative',
  },
  stickyContent: {
    position: 'sticky',
    top: 20,
    display: 'flex',
    flexDirection: 'column',
    gap: 24,
  },
});
